import { TwoFactorRequiredModal as SharedTwoFactorRequiredModal } from "@/shared/components/overlays/TwoFactorRequiredModal";
import useTranslations from "@/shared/lang/useTranslations";

export interface TwoFactorRequiredModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reason: "create_card" | "view_card" | "topup_card" | "move_card";
  onGoToSettings: () => void;
  /** A security PIN was just created in the notice: carry on with the card action that asked for it. */
  onEnrolled?: () => void;
}

const DESCRIPTION_KEYS = {
  create_card: "two_factor_required_to_create_card",
  view_card: "two_factor_required_to_view_card",
  topup_card: "two_factor_required_to_topup_card",
  move_card: "two_factor_required_to_move_card",
} as const;

/** The cards-flavoured entry point of the shared enrolment notice: a card `reason` picks the sentence. */
export function TwoFactorRequiredModal({
  open,
  onOpenChange,
  reason,
  onGoToSettings,
  onEnrolled,
}: TwoFactorRequiredModalProps) {
  const { t } = useTranslations("cards");

  return (
    <SharedTwoFactorRequiredModal
      open={open}
      onOpenChange={onOpenChange}
      description={t(DESCRIPTION_KEYS[reason])}
      onGoToSettings={onGoToSettings}
      onEnrolled={onEnrolled}
    />
  );
}
